module.exports = __webpack_public_path__ + "img/Wp_2038.26bf12c7.png";